import {
    FETCH_MEMBERS,
    FETCH_MEMBERS_SUCCESS
} from '../actions/Member';

const INITIAL_STATE = {
    members: {},
    isMembersLoading: false,
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_MEMBERS:
            return { ...state, isMembersLoading: true };
        case FETCH_MEMBERS_SUCCESS:
            return { ...state, isMembersLoading: false, members: action.payload }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/MemberReducer.js